import { AppStateModel, StoreSelectors } from '@store/app.reducer';
import { createSelector } from '@ngrx/store';
import { getIdTitleEngItem } from '@core/helpers';

export const selectDirectoriesFeature = (state: AppStateModel) => state[StoreSelectors.Directories];

// TODO: delete selectDeviceGroups if no usage
export const selectDeviceGroups = createSelector(selectDirectoriesFeature, (state) => state.deviceGroups);
export const selectBrands = createSelector(selectDirectoriesFeature, (state) => state.deviceBrands);
export const selectBrandsArray = createSelector(selectDirectoriesFeature, (state) => state.brands);
export const selectInterfaces = createSelector(selectDirectoriesFeature, (state) => state.deviceInterfaces);
export const selectInterfacesArray = createSelector(selectDirectoriesFeature, (state) => state.interfaces);
export const selectInterfacesForSelectors = createSelector(selectInterfacesArray, (interfaces) =>
    interfaces.map((w) => getIdTitleEngItem(w))
);

export const selectMessageGroups = createSelector(selectDirectoriesFeature, (state) => state.messageGroups);
export const selectMessageTypes = createSelector(selectDirectoriesFeature, (state) => state.messageTypes);
